export default "__VITE_ASSET__h$g3Okds__"